<template>
<div class="chapter">
<div class="inner_page">
<div id="acknowledgements">
<p class="noindent"><span class="big">THANKS</span> to Bruce Romanek for starting it all that day in Grant Park so long ago. Thanks to Dave Dewitt for starting my career in writing. Thanks to Scott Mendel for always putting me in the right place. Thanks to Bill LeBlond for always having faith in me. Thanks to Leigh Beisch for the great photos. Thanks to Tim Bryan for bringing the smoke! Thanks to Alice Chau for making it all look good. Thanks to my parents for giving me the tools. Thanks to Marsha for another great recipe. Thanks to Sandi for putting up with me while I write.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003acknowledgements.vue?4343b02e